/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkboxColumnId", {
  enumerable: true,
  get: function get() {
    return _defaultCheckColumnId.id;
  }
});
exports.default = void 0;
var _renderCheckbox = _interopRequireDefault(require("./renderCheckbox"));
var _defaultCheckColumnId = require("./defaultCheckColumnId");
var _default = {
  id: _defaultCheckColumnId.id,
  checkboxColumn: true,
  autoLock: true,
  cellSelectable: false,
  headerAlign: 'center',
  textAlign: 'center',
  render: function render(_ref) {
    var cellProps = _ref.cellProps;
    return (0, _renderCheckbox.default)(cellProps);
  },
  header: _renderCheckbox.default,
  showColumnMenuSortOptions: false,
  showColumnMenuGroupOptions: false,
  showColumnMenuTool: false,
  showInContextMenu: false,
  sortable: false,
  editable: false,
  draggable: false,
  groupBy: false,
  checkboxTabIndex: null,
  defaultWidth: 40,
  minWidth: 40,
  isCheckboxColumn: true
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/normalizeColumns/defaultCheckColumn.js
// module id = 612
// module chunks = 0